<app-alert-concluir-pedido-estoque-papel [alertConcluirPedido]='alertConcluirPedido'
  (confirmarPedido)="criarPedido($event)" [benefitDetails]='listaProdutos[0]'
  (alertConcluirPedidoFechou)="alertConcluirPedidoFechou($event)">
</app-alert-concluir-pedido-estoque-papel>
<app-header></app-header>
<app-loading-generico [loadingGenerico]="loadingGenerico"></app-loading-generico>
<app-botao-chat></app-botao-chat>
<app-alerta-exclusao-beneficio [showAlertaExclusaoBeneficio]="showAlertaExclusaoBeneficio"
  (alertaExclusaoBeneficioFechou)="exclusaoBeneficioFechou($event)"
  [indexBeneficio]="indexBeneficio"
></app-alerta-exclusao-beneficio>

<app-alert-erro-padrao [showAlertaErro]="showAlertErro"
  (alertErroPadraoFechou)="alertaErroFechou()"
  [descricaoErro]="descricaoErro"
></app-alert-erro-padrao>
<app-alert-descartar-alteracoes [show]="this.showAlertDescartarAlteracoes"
  (confirmouDescarte)="this.cancelarPedido($event)"
(cancelouDescarte)="fecharAlertDescartarAleracoes($event)"></app-alert-descartar-alteracoes>
<div class="container py-4">
  <div class="row">
    <div class="col-12">
      <div class="card" style="padding: 5px 24px 24px 24px;">
        <div>
          <app-breadcrumb></app-breadcrumb>
          <div class="div-titulo-pagina">
            <h1>Vale Papel</h1>
            <h2>Pedido simplificado apenas para benefícios em papel</h2>
          </div>
        </div>
        <div class="ajuste-row" [formGroup]="form" style="border-radius: 10px 10px 0 0;">
          <div class="col-lg-12" style="padding: 24px 24px 0 24px;position: relative">
            <mat-form-field class="select-vale-papel" appearance="outline"
              [ngClass]="{ 'select-invalid-test': enderecoSemBeneficio }">
              <mat-label class="mat-label-text">Selecione o endereço de entrega</mat-label>
              @if (form.value.endereco !== null && !enderecoSemBeneficio) {
                <span matPrefix>
                  <i class="fa fa-check-circle fa-lg" style="color: #BDD753;"
                  aria-hidden="true"></i>
                </span>
              }
              @if (enderecoSemBeneficio) {
                <span matPrefix>
                  <i class="fa fa-times-circle fa-lg" style="color: #D2373C;"
                  aria-hidden="true"></i>
                </span>
              }
              <mat-select #singleSelect disableOptionCentering panelClass="select-endereco-vp"
                panelWidth="100%"
                formControlName="endereco"
                (valueChange)="onChangeEnderecoEntrega($event)" required>
                <mat-option>
                  <ngx-mat-select-search
                    noEntriesFoundLabel="Nenhum endereço encontrado."
                    [formControl]="filtroEndereco"
                    placeholderLabel="Buscar">
                  </ngx-mat-select-search>
                </mat-option>
                @for (endereco of enderecosCadastrados | async; track endereco) {
                  <mat-option [value]="endereco">
                    {{endereco.descricaoReferencia}}
                  </mat-option>
                }
              </mat-select>
              <mat-error style="margin-top: -13px">
                @if (enderecoSemBeneficio) {
                  <div>
                    Nenhum benefício encontrado. Favor selecionar outro endereço.
                  </div>
                }
                @if (form.get('endereco')!.invalid && !enderecoSemBeneficio) {
                  <div>
                    Campo obrigatório.
                  </div>
                }
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-lg-12"
            style="padding: 24px 24px 0 24px;position: relative;display: flex;gap: 10px">
            <mat-form-field class="select-vale-papel" appearance="outline">
              <mat-label class="mat-label-text">Selecione o benefício</mat-label>
              @if (idProduto !== 0) {
                <span matPrefix>
                  <i class="fa fa-check-circle fa-lg" style="color: #BDD753;margin-right: 5px;"
                  aria-hidden="true"></i>
                </span>
              }
              <mat-error style="margin-top: -13px">
                @if (form.get('produto')!.invalid) {
                  <div>
                    Campo obrigatório.
                  </div>
                }
              </mat-error>
              <mat-select #singleSelect disableOptionCentering panelClass="select-produto-vp" formControlName="produto"
                (valueChange)="onChangeProdutoSelecionado($event)" required>
                <mat-option>
                  <ngx-mat-select-search
                    noEntriesFoundLabel="Nenhum benefício encontrado."
                    [formControl]="filtroBeneficio"
                    placeholderLabel="Buscar">
                  </ngx-mat-select-search>
                </mat-option>
                @for (beneficio of produtosCadastrados | async; track beneficio) {
                  <mat-option [value]="beneficio">
                    {{beneficio.descricaoProduto}}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <mat-form-field class="form-quantidade-vale" appearance="outline">
              <mat-label class="mat-label-text">Quantidade</mat-label>
              <input matInput type="text" formControlName="quantidade" maxlength="6" id="inptQuantidade" required>
              <mat-error style="margin-top: -13px">
                @if (form.get('quantidade')!.invalid) {
                  <div>
                    {{form.get(['quantidade'])!.hasError('max') ? 'Valor máximo atingido' : 'Campo Obrigatório'}}
                  </div>
                }
              </mat-error>
            </mat-form-field>
            <div class="tooltip-quantidade-vale">
              <div style="margin-top: 15px;">
                <i class="fa fa-info-circle fa-lg"></i>
                <div class="dropdown-info-vale">
                  <div class="container-info-vale">
                    <div style="width: 250px;white-space: break-spaces;color: #878787">
                      <h1>Importante!</h1>
                      <p>A quantidade deve ser maior que 0 (zero) e respeitar o valor máximo aceito. </p>
                      <div class="triangulo-tooltip"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-12" style="display: flex;padding: 0 24px 24px; margin-top: 20px;">
            <button class="botao-incluir-vale-papel ajuste-botao" id="btnIncluir" (click)="adicionarBeneficio()">INCLUIR
            </button>
          </div>
        </div>
        @if (listaProdutos.length) {
          <div>
            <div class="table-vale-papel">
              <table class="table table-hover">
                <caption>Tabela com lista de pedidos de estoque de papel</caption>
                <thead>
                  <tr>
                    <th scope="col">CÓDIGO</th>
                    <th scope="col">DESCRIÇÃO</th>
                    <th scope="col">QUANTIDADE</th>
                    <th scope="col">UNIDADE</th>
                    <th scope="col">SUBTOTAL</th>
                    <th scope="col"></th>
                  </tr>
                </thead>
                <tbody>
                  @for (produto of $safeNavigationMigration(listaProdutos[0]?.produtos) | paginate: { id: 'itensValePapel', itemsPerPage: itensPorPagina, currentPage: paginaAtual, totalItems: totalItens }; track produto; let i = $index) {
                    <tr
                      >
                      <td>{{ produto.codVenda }}</td>
                      <td>{{ produto.descricao }}</td>
                      <td>{{ produto.qtde }}</td>
                      <td>{{ produto.valorUnitario }}</td>
                      <td>{{ produto.subTotal }}</td>
                      <td>
                        <button class="btn pt-0" id="btnDeletarItem{{i}}" (click)="onItemDeleted(i)">
                          <i class="fa fa-trash fa-lg c-primary" aria-hidden="true"></i>
                        </button>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
            <div class="paginacao-padding">
              <div style="display: flex;margin-left: 14px" class="exibicao-paginacao">
                <span><p>Exibir</p></span>
                <div class="select-registros-vale">
                  <app-select
                    ngClass="form-control-selecao select-registros-vale"
                    [value]="itensPorPagina"
                    (valueChanges)="itensPorPaginaAlterou($event)"
                    name="itensPorPaginaVale"
                    id="itensPorPaginaVale"
                  [options]="[
                            {name : '7 REGISTROS' , value : '7'} ,
                            {name : '14 REGISTROS' , value : '14'},
                            {name : '21 REGISTROS' , value : '21'}
                            ]"
                    optionValue="value"
                    optionText="name">
                  </app-select>
                  <i class="fa fa-caret-down c-primary" aria-hidden="true"></i>
                </div>
                <span><p> por página</p></span>
              </div>
              <div class="paginacao-centro-padding">
                <pagination-controls id="itensValePapel" class="itens-pagina" (pageChange)="getPaginaBeneficios($event)"
                  directionLinks="false" autoHide="false"
                  responsive="true" previousLabel="" nextLabel=""
                  screenReaderPaginationLabel="Pagination" screenReaderPageLabel="page"
                  screenReaderCurrentLabel="Página">
                </pagination-controls>
              </div>
              <div class="paginacao-direita-padding">
                <div class="row" style="justify-content: right">
                  <span class="subtitulo-table"><p><b style="font-weight: 600">{{listaProdutos[0]?.produtos.length}}</b> Registros foram encontrados</p></span>
                </div>
              </div>
            </div>
            <div class="ajuste-row table-vale-papel"
              style="display: flex;justify-content: space-between;height: 80px;border-radius: 0 0 10px 10px;">
              <div style="width: 17%;margin-left: 24px;margin-right: 24px">
                <p>Total de Vales</p>
                <span>{{listaProdutos[0]?.totalVales}}</span>
              </div>
              <div style="width: 17%;margin-left: 24px;margin-right: 24px">
                <p>Outras Cobranças</p>
                <span>{{listaProdutos[0]?.totalOutrasCobrancas}}</span>
              </div>
              <div style="width: 17%;margin-left: 24px;margin-right: 24px">
                <p>Total da taxa</p>
                <span>{{listaProdutos[0]?.totalTaxa}}</span>
              </div>
              <div style="width: 17%;margin-left: 24px;margin-right: 24px">
                <p>Descontos</p>
                <span>{{listaProdutos[0]?.totalDescontos}}</span>
              </div>
              <div style="width: 30%;	border-left: 2px solid #D8D8D8;">
                <p style="margin: 25px 0 0 50px;color: #0E7F61!important;">Total a
                pagar: {{listaProdutos[0]?.totalPagar}}</p>
              </div>
            </div>
          </div>
        }


        <div id="dadosPagamentoValePapel" class="row mt-5" [formGroup]="form2">
          @if (prePago) {
            <div class="mb-4 col-lg-4 mt-4">
              <mat-form-field class="form-dtpagamento-vale w-100" appearance="outline">
                <mat-label class="mat-label-text">Data de Pagamento</mat-label>
                <mat-error style="margin-top: -13px">
                  @if (form2.get('dtPagamento')!.invalid && dataPagamento === null) {
                    <div>
                      Campo Obrigatório
                    </div>
                  }
                  @if (dataPagamentoError && dataPagamento !== null) {
                    <div>
                      {{dataPagamentoMessageError}}
                    </div>
                  }
                </mat-error>
                <input matInput required type="text"
                  id="inptDtPagamento" dateMask [matDatepicker]="picker1"
                  formControlName="dtPagamento" (change)="onDataPagamento()"
                  [(ngModel)]="dataPagamento"
                  (dateChange)="onDataPagamento()">
                <mat-datepicker-toggle matSuffix [for]="picker1" class="datepicker-custom" style="margin-top: 5px">
                  <mat-icon matDatepickerToggleIcon >
                    <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M6.50008 1.41591C6.50008 0.955677 6.12699 0.582581 5.66675 0.582581C5.20651 0.582581 4.83341 0.955677 4.83341 1.41591V2.24925H4.00008C2.15913 2.24925 0.666748 3.74163 0.666748 5.58258V15.5826C0.666748 17.4235 2.15913 18.9159 4.00008 18.9159H14.0001C15.841 18.9159 17.3334 17.4235 17.3334 15.5826V5.58258C17.3334 3.74163 15.841 2.24925 14.0001 2.24925H13.1667V1.41591C13.1667 0.955677 12.7937 0.582581 12.3334 0.582581C11.8732 0.582581 11.5001 0.955677 11.5001 1.41591V2.24925H6.50008V1.41591ZM12.3334 4.74925C11.8732 4.74925 11.5001 4.37615 11.5001 3.91591H6.50008C6.50008 4.37615 6.12699 4.74925 5.66675 4.74925C5.20651 4.74925 4.83341 4.37615 4.83341 3.91591H4.00008C3.07961 3.91591 2.33341 4.66211 2.33341 5.58258V7.24925H15.6667L15.6667 5.58258C15.6667 4.66211 14.9206 3.91591 14.0001 3.91591H13.1667C13.1667 4.37615 12.7937 4.74925 12.3334 4.74925ZM15.6667 8.91591H2.33341V15.5826C2.33341 16.5031 3.07961 17.2492 4.00008 17.2492H14.0001C14.9206 17.2492 15.6667 16.5031 15.6667 15.5826L15.6667 8.91591ZM9.84155 11.4159C9.84156 11.8761 9.46847 12.2492 9.00823 12.2492H8.99987C8.53963 12.2493 8.16653 11.8762 8.16652 11.4159C8.16652 10.9557 8.53961 10.5826 8.99985 10.5826H9.00821C9.46845 10.5826 9.84155 10.9557 9.84155 11.4159ZM9.00823 15.5826C9.46847 15.5826 9.84156 15.2095 9.84155 14.7492C9.84155 14.289 9.46845 13.9159 9.00821 13.9159H8.99985C8.53961 13.9159 8.16652 14.289 8.16652 14.7493C8.16653 15.2095 8.53963 15.5826 8.99987 15.5826H9.00823ZM14.0082 11.4159C14.0082 11.8761 13.6351 12.2492 13.1749 12.2492H13.1665C12.7063 12.2493 12.3332 11.8762 12.3332 11.4159C12.3332 10.9557 12.7063 10.5826 13.1665 10.5826H13.1749C13.6351 10.5826 14.0082 10.9557 14.0082 11.4159ZM13.1749 15.5826C13.6351 15.5826 14.0082 15.2095 14.0082 14.7492C14.0082 14.289 13.6351 13.9159 13.1749 13.9159H13.1665C12.7063 13.9159 12.3332 14.289 12.3332 14.7493C12.3332 15.2095 12.7063 15.5826 13.1665 15.5826H13.1749ZM5.43081 10.8267C5.75625 11.1521 5.75625 11.6797 5.43081 12.0052L5.42247 12.0135C5.09703 12.3389 4.56939 12.3389 4.24396 12.0135C3.91852 11.6881 3.91852 11.1604 4.24396 10.835L4.2523 10.8267C4.57773 10.5012 5.10537 10.5012 5.43081 10.8267ZM4.84156 15.5826C5.3018 15.5826 5.67489 15.2095 5.67489 14.7492C5.67488 14.289 5.30178 13.9159 4.84154 13.9159H4.83318C4.37294 13.9159 3.99985 14.289 3.99986 14.7493C3.99986 15.2095 4.37296 15.5826 4.8332 15.5826H4.84156Z" fill="#878787"/>
                    </svg>
                  </mat-icon>
                </mat-datepicker-toggle>
                <mat-datepicker #picker1></mat-datepicker>
              </mat-form-field>
            </div>
          }
          <!-- INICIO DA DIV TRANSPARENTE SÓ PARA MANTER A ESTRUTURA DA PAGINA -->
          @if (!prePago) {
            <div class="mb-4 col-lg-4 mt-4"></div>
          }
          <!-- FIM DA DIV TRANSPARENTE SÓ PARA MANTER A ESTRUTURA DA PAGINA -->
          <div class="mb-4 col-lg-4 mt-4">
            <div class="mb-3">
              <mat-form-field class="form-email-vale" appearance="outline">
                <mat-label class="mat-label-text">Selecione o endereço de faturamento</mat-label>
                <mat-error style="margin-top: -13px">
                  @if (form2.get('enderecoFaturamento')!.invalid) {
                    <div>
                      Campo obrigatório.
                    </div>
                  }
                </mat-error>
                <mat-select
                  #selectEnderecoFaturamento
                  disableOptionCentering
                  panelClass="select-faturamento"
                  [panelWidth]="'600px'"
                  formControlName="enderecoFaturamento"
                  (valueChange)="onChangeEnderecoFaturamento($event)"
                  required>
                  @for (endereco of enderecosFaturamento; track endereco) {
                    <mat-option [value]="endereco">
                      {{endereco.descricaoReferencia}}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <div class="mb-4 col-lg-4 mt-4">
            <div class="mb-3">
              <mat-form-field class="form-email-vale" appearance="outline">
                <mat-label class="mat-label-text">Selecione o contato de faturamento</mat-label>
                <mat-error style="margin-top: -13px">
                  @if (form2.get('contatoFaturamento')!.invalid) {
                    <div>
                      Campo obrigatório.
                    </div>
                  }
                </mat-error>
                <mat-select #singleSelect disableOptionCentering panelClass="select-faturamento" formControlName="contatoFaturamento"
                  (valueChange)="onChangeContatoFaturamento($event)" required>
                  @for (contato of contatosCadastrados; track contato) {
                    <mat-option [value]="contato">
                      {{contato.nome}}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <div class="col-6 col-lg">
            <div class="mb-4">
              <mat-form-field class="form-email-vale" appearance="outline">
                <mat-label class="mat-label-text">E-mail para confirmação</mat-label>
                <mat-error style="margin-top: -13px">
                  @if (form2.get('emailConfirmacao')!.invalid && emailConfirmacao === '') {
                    <div>
                      Campo Obrigatório
                    </div>
                  }
                  @if (emailConfirmacaoError && emailConfirmacao.length) {
                    <div>
                      {{campoEmailErrorMessage}}
                    </div>
                  }
                </mat-error>
                <input type="email" matInput id="inptEmailConfirmacao" required
                  [(ngModel)]="emailConfirmacao" (blur)="onEmailConfirmacao()" formControlName="emailConfirmacao"/>
              </mat-form-field>
            </div>
          </div>
          <div class="col-6 col-lg">
            <div class="mb-4">
              <mat-form-field class="form-email-vale" appearance="outline">
                <mat-label class="mat-label-text">E-mail para envio de Nota Fiscal (1)</mat-label>
                <mat-error style="margin-top: -13px">
                  @if (form2.get('emailNF')!.invalid && emailNf === '') {
                    <div>
                      Campo Obrigatório
                    </div>
                  }
                  @if (emailNfError && emailNf.length) {
                    <div>
                      {{campoEmailNfErrorMessage}}
                    </div>
                  }
                </mat-error>
                <input type="email" matInput id="emailNfe1" required
                  [(ngModel)]="emailNf" (blur)="onEmailNf()" formControlName="emailNF"
                  [ngClass]="{ 'is-invalid': emailNfError }"/>
              </mat-form-field>
            </div>
          </div>
          <div class="col-6 col-lg">
            <div class="mb-3">
              <mat-form-field class="form-email-vale" appearance="outline">
                <mat-label class="mat-label-text">E-mail para envio de Nota Fiscal (2)</mat-label>
                <mat-error style="margin-top: -13px;">
                  @if (form2.get('emailNF2')!.invalid && emailNf2 === '') {
                    <div>
                      Campo Obrigatório
                    </div>
                  }
                  @if (emailNf2Error && emailNf2.length) {
                    <div>
                      {{campoEmailNf2ErrorMessage}}
                    </div>
                  }
                </mat-error>
                <input type="email" matInput id="emailNfe2" required
                  [(ngModel)]="emailNf2" (blur)="onEmailNf2()" formControlName="emailNF2"
                  [ngClass]="{ 'is-invalid': emailNf2Error }"/>
              </mat-form-field>
            </div>
          </div>
        </div>
        <div class="row w-100" id="botoesPedido">
          <div class="col-2 text-start mb-3 mt-5">
            <button type="button" id="btnCancelarSolicitacaoPedido" (click)="alertDescartarAlteracoes()"
              class="btn botao-outline w-auto">CANCELAR
            </button>
          </div>
          <div class="col-8 text-start mb-3 mt-5"></div>
          <div class="col-2 text-rigth mb-3 mt-5">
            <button type="button" style="margin-left: 30px;" id="btnConcluirSolicitacaoPedido"
              class="text-rigth  btn-borda-verde bnt-font btn-grande-verde w-100"
              (click)='alertaPedido()'>CONCLUIR PEDIDO
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>
